<template>
  <div class="panel-group">
    <div class="panel-wrapper">
      <div class="panel-wrapper-header">
        <div class="panel-wrapper-header-tabs">
          <widgetTabs v-model="activeTab" :tabs="[
            {
              title: 'Inbox',
              value: 'inbox',
              icon: {
                inactive: require('@/assets/icons/inbox-gray.svg'),
                active: require('@/assets/icons/inbox-green.svg')
              }
            },
            {
              title: 'Sent',
              value: 'sentEmails',
              icon: {
                inactive: require('@/assets/icons/sent-email-gray.svg'),
                active: require('@/assets/icons/sent-email-green.svg')
              }
            }
          ]" @change="switchTab"></widgetTabs>

        </div>
      </div>
      <div class="panel-wrapper-body" @scroll="handleScroll">
        <div class="content-loading-container" v-if="loading_page_data && !inboxEmails.length">
          <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="loading_page_data"
            :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
        </div>

        <div class="not-found" v-if="inboxEmails.length === 0 && !loading_page_data">
          <widgetNotFoundWidget title="No Emails Found" content="Your inbox is empty" align="center">
            <img class="widget-img" src="@/assets/icons/select-item.svg" />
          </widgetNotFoundWidget>
        </div>

        <div class="panel-wrapper-body-container" v-if="inboxEmails.length > 0">
          <div class="inbox-email-item" v-for="(item, index) in inboxEmails" :key="index" @click="selectItem(item)"
            :class="{
              active:
                selected_item_details && item.id === selected_item_details.id,
            }">
            <div class="inbox-email-item-header">
              <div class="inbox-email-item-header-profile" v-if="item.name">
                <widgetProfile :title="item.name" :subtitle="''" :file_name="null" :path="$fullUrl('images/profiles/')"
                  :size="25" :text_size="11"></widgetProfile>
              </div>
              <div class="inbox-email-item-header-title">{{ item.subject }}</div>
            </div>
            <div class="inbox-email-item-body">
              <div v-if="false" class="inbox-email-item-body-text">
                {{ htmlToText(item.message) }}
              </div>
            </div>
          </div>

          <!-- Bottom loader -->
          <div class="bottom-loader" v-if="loading_page_data">
            <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="loading_page_data"
              :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
          </div>
        </div>
      </div>
    </div>
    <div class="email-inbox-preview">
      <!-- Tab content details for email -->
      <div class="email-preview-details" v-show="selected_item_details">
        <div class="email-preview-header">
          <div class="email-preview-header-left">
            <div class="email-info" v-if="selected_item_details">
              <h3 class="email-subject">{{ selected_item_details.subject }}</h3>
              <p class="email-meta">
                <strong>From:</strong> {{ selected_item_details.from }}
              </p>
              <p class="email-meta" v-if="selected_item_details.to">
                <strong>To:</strong> {{ selected_item_details.to }}
              </p>
              <p class="email-meta">
                <strong>Date:</strong> {{ new Date(selected_item_details.date).toLocaleString() }}
              </p>
            </div>
          </div>
          <div class="email-preview-options" v-if="selected_item_details">
            <dropdown-menu>
              <ul>
                <li>
                  <app-dialog title="Delete Email" ask="Are you sure you want to delete this email?" yesText="Delete"
                    noText="Cancel" @onComfirm="deleteEmail(selected_item_details)">
                    <a>Delete Email</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>
        </div>

        <div class="email-preview-body">
          <iframe ref="emailBodyFrame" style="width: 100%; height: 100%; border: none;"></iframe>
        </div>

        <div class="email-preview-attachments"
          v-if="selected_item_details && selected_item_details.attachments && selected_item_details.attachments.length > 0">
          <h4>Attachments:</h4>
          <ul>
            <li v-for="(attachment, index) in selected_item_details.attachments" :key="index">
              {{ attachment.filename }} ({{ formatFileSize(attachment.size) }})
            </li>
          </ul>
        </div>
      </div>

      <!-- When no item selected -->
      <div class="widget-notfound" v-if="!selected_item_details">
        <widgetNotFoundWidget title="No email selected" content="Select an email to view its details" align="center">
          <img class="widget-img" src="@/assets/icons/select-item.svg" />
        </widgetNotFoundWidget>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "",
  components: {},
  props: {
    phase: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      selected_item_details: null,
      inboxEmails: [],
      loading_page_data: false,
      activeTab: 1,
      pageToken: null
    };
  },
  mounted() {
    let vm = this;
    eventBus.$on("inboxEmailRefresh", () => {
      vm.getInboxEmails(true);
    });
    vm.getInboxEmails(true);
  },
  computed: {},
  watch: {
    selected_item_details(newItem) {
      this.$nextTick(() => {
        const iframe = this.$refs.emailBodyFrame;
        if (iframe) {
          if (newItem && newItem.message) {
            iframe.onload = () => {
              // Optional: Add any iframe content manipulation here
            };
            iframe.srcdoc = this.formatEmailContent(newItem.message);
          } else {
            iframe.srcdoc = '<html><body style="background-color: #fafafa; padding: 20px; font-family: Arial, sans-serif;"><p>No email content available</p></body></html>';
          }
        } else {
          console.warn('InboxEmailPanel: emailBodyFrame ref not found during watch update.');
        }
      });
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.$emit("switchTab", tab.value);
    },
    selectItem(item) {
      let vm = this;
      vm.selected_item_details = item;
    },
    deleteEmail(item) {
      let vm = this;
      vm.$store
        .dispatch("EMAIL_DELETE_INBOX", { id: item.id })
        .then((responce) => {
          vm.selected_item_details = null;
          vm.getInboxEmails();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Email is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          item.loading = false;
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something wrong while deleting email",
            type: "warn",
            duration: 3000,
          });
        });
    },
    getInboxEmails(initialData = false) {
      let vm = this;
      vm.loading_page_data = true;
      vm.$store
        .dispatch("EMAIL_GET_ALL_INBOX", { pageToken: vm.pageToken, initialData: initialData })
        .then((responce) => {
          vm.loading_page_data = false;
          vm.pageToken = responce.data.pageToken;
          if (initialData) {
            vm.inboxEmails = vm.formattedEmail(responce.data.data);
          } else {
            // push new item to inboxEmails
            let newItems = vm.formattedEmail(responce.data.data);
            vm.inboxEmails.push(...newItems);
          }
        })
        .catch((error) => {
          vm.loading_page_data = false;
        });
    },
    formattedEmail(data) {
      return data.map((item) => {
        const headers = item.payload.headers;
        const attachments = [];
        let message = '';
        let name = '';
        let messageType = ''; // To track if we got HTML or plain text

        // Extract name from From header
        const fromHeader = headers.find(h => h.name === "From")?.value || "";
        const nameMatch = fromHeader.match(/^"?([^"<]+)"?\s*<?.*>?$/);
        name = nameMatch ? nameMatch[1].trim() : fromHeader;

        // Function to find and decode a specific mimeType part
        function findPart(parts, mimeType) {
          for (const part of parts) {
            if (part.mimeType === mimeType && part.body && part.body.data) {
              return atob(part.body.data.replace(/-/g, '+').replace(/_/g, '/'));
            }
            if (part.parts) {
              const nestedPartData = findPart(part.parts, mimeType);
              if (nestedPartData) return nestedPartData;
            }
          }
          return null;
        }

        // Function to extract attachments
        function extractAttachments(parts) {
          parts.forEach(part => {
            if (part.filename && part.mimeType && !part.mimeType.startsWith('text/') && part.body && part.body.attachmentId) {
              attachments.push({
                filename: part.filename,
                mimeType: part.mimeType,
                attachmentId: part.body.attachmentId,
                size: part.body.size || 0
              });
            }
            if (part.parts) {
              extractAttachments(part.parts);
            }
          });
        }


        if (item.payload.parts) {
          // Try to get HTML part first
          message = findPart(item.payload.parts, 'text/html');
          messageType = message ? 'html' : '';

          // If no HTML, try to get plain text part
          if (!message) {
            message = findPart(item.payload.parts, 'text/plain');
            messageType = message ? 'plain' : '';
          }
          // Extract attachments from all parts
          extractAttachments(item.payload.parts);

        } else if (item.payload.body && item.payload.body.data) {
          // Handle case where message is in the main body (less common for multipart)
          // We assume this is HTML if not specified, or could be plain.
          // For simplicity, let's assume it could be HTML or treat as plain if no specific mime type.
          // Gmail API usually gives mimeType for the payload itself.
          if (item.payload.mimeType === 'text/html') {
            message = atob(item.payload.body.data.replace(/-/g, '+').replace(/_/g, '/'));
            messageType = 'html';
          } else if (item.payload.mimeType === 'text/plain') {
            message = atob(item.payload.body.data.replace(/-/g, '+').replace(/_/g, '/'));
            messageType = 'plain';
          } else { // Fallback if mimeType is not explicitly text/html or text/plain
            message = atob(item.payload.body.data.replace(/-/g, '+').replace(/_/g, '/'));
            messageType = 'plain'; // Treat as plain by default if unknown
          }
        }

        // If message is plain text, convert newlines to <br>
        if (message && messageType === 'plain') {
          message = message.replace(/\\r\\n/g, '<br>').replace(/\\n/g, '<br>');
        }

        // Fallback to snippet if no message body found
        if (!message) {
          message = item.snippet;
          // Sanitize snippet as well if it's to be rendered with v-html and might contain HTML entities
          // For now, assuming snippet is plain text like and needs newline conversion
          message = message.replace(/\\r\\n/g, '<br>').replace(/\\n/g, '<br>');
        }


        const formattedEmail = {
          id: item.id,
          threadId: item.threadId,
          historyId: item.historyId,
          internalDate: item.internalDate,
          snippet: item.snippet,
          sizeEstimate: item.sizeEstimate,
          // Extract relevant header information
          from: headers.find(h => h.name === "From")?.value || "",
          to: headers.find(h => h.name === "To")?.value || "",
          subject: headers.find(h => h.name === "Subject")?.value || "",
          date: headers.find(h => h.name === "Date")?.value || "",
          // Add name and message
          name: name,
          message: message || item.snippet, // Fallback to snippet if no message body found
          // Add attachments array
          attachments: attachments,
          // Add required UI state properties
          editing: false,
          loading: false
        };

        return formattedEmail;
      });
    },
    handleScroll(e) {
      let vm = this;
      if (vm.pageToken) {
        const element = e.target;
        if (!vm.loading_page_data && element.scrollHeight - element.scrollTop === element.clientHeight) {
          vm.getInboxEmails();
        }
      }
    },
    formatFileSize(size) {
      if (size < 1024) {
        return size + ' B';
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB';
      } else if (size < 1024 * 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + ' MB';
      } else {
        return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
      }
    },
    formatEmailContent(content) {
      // Check if content looks like HTML
      if (content && (content.includes('<') || content.includes('&'))) {
        return `
          <html>
            <head>
              <style>
                body {
                  font-family: 'Nunito', Arial, sans-serif;
                  font-size: 14px;
                  line-height: 1.6;
                  color: #333;
                  margin: 20px;
                  background-color: #fafafa;
                }
                p { margin: 0 0 10px 0; }
                ul, ol { margin: 0 0 10px 20px; padding-left: 20px; }
                li { margin-bottom: 5px; }
                a { color: #1a73e8; text-decoration: underline; }
                a:hover { color: #135abc; }
                h1, h2, h3, h4, h5, h6 {
                  font-family: 'Nunito', Arial, sans-serif;
                  color: #1c1c1c;
                  margin-top: 20px;
                  margin-bottom: 10px;
                  font-weight: 600;
                }
                blockquote {
                  border-left: 4px solid #ccc;
                  margin: 10px 0;
                  padding-left: 15px;
                  color: #555;
                  font-style: italic;
                }
                pre {
                  background-color: #f5f5f5;
                  border: 1px solid #ddd;
                  border-radius: 4px;
                  padding: 10px;
                  overflow-x: auto;
                  font-family: monospace;
                  font-size: 13px;
                  white-space: pre-wrap;
                  word-wrap: break-word;
                }
                code {
                  font-family: monospace;
                  background-color: #f0f0f0;
                  padding: 2px 4px;
                  border-radius: 3px;
                  font-size: 0.9em;
                }
              </style>
            </head>
            <body>${content}</body>
          </html>
        `;
      } else {
        // Plain text content - convert newlines to <br>
        const formattedContent = content
          ? content.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>')
          : 'No content available';

        return `
          <html>
            <head>
              <style>
                body {
                  font-family: 'Nunito', Arial, sans-serif;
                  font-size: 14px;
                  line-height: 1.6;
                  color: #333;
                  margin: 20px;
                  background-color: #fafafa;
                }
              </style>
            </head>
            <body>${formattedContent}</body>
          </html>
        `;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.panel-group {
  width: 100%;
  display: flex;
  height: 100%;

  .panel-wrapper {
    width: 320px;
    height: 100%;

    .panel-wrapper-header {
      height: 50px;
      background: #ffffff;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;

      .panel-wrapper-header-tabs {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        width: 100%;

        .tabs-widget {
          display: flex;
          width: 100%;

          .tabs-item {
            display: flex;
            align-items: center;
            margin-right: 20px;
            cursor: pointer;

            .tabs-item-icon {
              margin-right: 5px;
              display: flex;
              align-items: center;
              height: 100%;

              img {
                width: 14px;
              }

              .active-icon {
                display: none;
              }
            }

            .tabs-item-title {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              color: #707070;
            }

            &.active,
            &:hover {
              .tabs-item-title {
                color: #1ba5a4;
              }

              .tabs-item-icon {
                .inactive-icon {
                  display: none;
                }

                .active-icon {
                  display: block;
                }
              }
            }
          }
        }
      }
    }

    .panel-wrapper-body {
      height: calc(100% - 50px);
      overflow-y: auto;
      border-bottom-left-radius: 7px;
      border-bottom-right-radius: 7px;

      .panel-wrapper-body-container {
        background: #ffffff;
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
        padding-bottom: 10px;

        .inbox-email-item {
          padding: 6px 6px;
          transition: 0.3s ease-in-out;
          cursor: pointer;

          &:hover {
            background: #f4f4f4;
            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
            transition: 0.1s ease-in-out;
          }

          &.active {
            background: #f4f4f4;
            transition: 0.1s ease-in-out;
          }

          .inbox-email-item-header {
            display: flex;
            flex-direction: column;
            margin-bottom: 7px;

            .inbox-email-item-header-profile {
              margin-right: 5px;
              margin-bottom: 10px;
            }

            .inbox-email-item-header-title {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 700;
              font-size: 12px;
              line-height: 19px;
              color: #1c1c1c;
            }
          }

          .inbox-email-item-body {
            .inbox-email-item-body-text {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 400;
              font-size: 11px;
              color: #8e8b8b;
              overflow: hidden;
              display: block;
              max-height: 4rem;
              -webkit-line-clamp: 2;
              display: box;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              white-space: normal;
            }
          }
        }

        .bottom-loader {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 10px 0;
          background: #ffffff;
          position: relative;
        }
      }

      .content-loading-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background: #ffffff;
      }

      .not-found {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background: #ffffff;
      }
    }
  }

  .email-inbox-preview {
    width: calc(100% - 320px);
    height: 100%;
    border-radius: 7px;
    margin-left: 5px;
    background-color: #fff;
    overflow-y: auto;

    .email-preview-details {
      width: 100%;
      min-height: 100%;
      border-radius: 5px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      padding: 15px;

      .email-preview-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding-bottom: 15px;
        border-bottom: 1px solid #eee;
        margin-bottom: 15px;

        .email-preview-header-left {
          display: flex;
          align-items: flex-start;

          .email-info {
            display: flex;
            flex-direction: column;

            .email-subject {
              font-family: "Nunito", sans-serif;
              font-size: 18px;
              font-weight: 700;
              color: #1c1c1c;
              margin: 0 0 8px 0;
            }

            .email-meta {
              font-family: "Nunito", sans-serif;
              font-size: 12px;
              color: #555;
              margin: 2px 0;

              strong {
                font-weight: 600;
              }
            }
          }
        }

        .email-preview-options {
          display: flex;
          align-items: center;
          margin-left: auto;
          padding-left: 15px;
        }
      }

      .email-preview-body {
        position: relative;
        padding: 0;
        /* Remove padding if iframe handles its own scrolling and content display */
        background: #fafafa;
        border-radius: 10px;
        flex-grow: 1;
        /* Allows body to take available space */
        /* overflow-y: auto; */
        /* Iframe will handle its own scroll */
        display: flex;
        /* To make iframe fill the container */
        font-family: "Nunito", sans-serif;
        /* Base font for email body */
        font-size: 14px;
        line-height: 1.6;
        color: #333;

        ::v-deep p {
          margin: 0 0 10px 0;
        }

        ::v-deep ul,
        ::v-deep ol {
          margin: 0 0 10px 20px;
          padding-left: 20px;
        }

        ::v-deep li {
          margin-bottom: 5px;
        }

        ::v-deep a {
          color: #1a73e8;
          text-decoration: underline;
        }

        ::v-deep a:hover {
          color: #135abc;
        }

        ::v-deep h1,
        ::v-deep h2,
        ::v-deep h3,
        ::v-deep h4,
        ::v-deep h5,
        ::v-deep h6 {
          font-family: "Nunito", sans-serif;
          color: #1c1c1c;
          margin-top: 20px;
          margin-bottom: 10px;
          font-weight: 600;
        }

        ::v-deep h1 {
          font-size: 2em;
        }

        ::v-deep h2 {
          font-size: 1.75em;
        }

        ::v-deep h3 {
          font-size: 1.5em;
        }

        ::v-deep h4 {
          font-size: 1.25em;
        }

        ::v-deep h5 {
          font-size: 1em;
        }

        ::v-deep h6 {
          font-size: 0.875em;
        }

        ::v-deep blockquote {
          border-left: 4px solid #ccc;
          margin: 10px 0 10px 0;
          padding-left: 15px;
          color: #555;
          font-style: italic;
        }

        ::v-deep pre {
          background-color: #f5f5f5;
          border: 1px solid #ddd;
          border-radius: 4px;
          padding: 10px;
          overflow-x: auto;
          font-family: monospace;
          font-size: 13px;
          white-space: pre-wrap;
          word-wrap: break-word;
        }

        ::v-deep code {
          font-family: monospace;
          background-color: #f0f0f0;
          padding: 2px 4px;
          border-radius: 3px;
          font-size: 0.9em;
        }
      }

      iframe {
        width: 100%;
        height: 100%;
        border: none;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }

      .email-preview-attachments {
        padding: 15px;
        background: #f0f0f0;
        border-radius: 8px;
        margin-top: 15px;

        h4 {
          font-family: "Nunito", sans-serif;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          margin: 0 0 10px 0;
        }

        ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            font-family: "Nunito", sans-serif;
            font-size: 13px;
            color: #444;
            padding: 5px 0;
            border-bottom: 1px dashed #ddd;

            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }

    .widget-notfound {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background: #ffffff;
    }
  }
}
</style>